// Импорты настоящих изображений недвижимости
import pearl22 from "../../assets/img/nft/Skyscraper1.jpg";
import emerald7 from "../../assets/img/nft/Skyscraper2.jpg";
import skyline9 from "../../assets/img/nft/Skyscraper3.jpg";
import platinum33 from "../../assets/img/nft/Skyscraper4.jpg";
import ocean15 from "../../assets/img/nft/Skyscraper5.jpg";
import techhub44 from "../../assets/img/nft/Skyscraper6.jpg";
export var NftContent = [
    {
        name: "Pearl Tower #1",
        img: pearl22,
        collectionName: "Pearl22",
        author: "KadorCity",
        bestOffer: "1420",
        floorPrice: 1180,
        currency: "QUANTA",
        annualYield: -12.5,
    },
    {
        name: "Diamond Heights #42",
        img: emerald7,
        collectionName: "Emerald7",
        author: "EmeraldPlaza",
        bestOffer: "710",
        floorPrice: 570,
        currency: "QUANTA",
        annualYield: 8.7,
    },
    {
        name: "Golden Gate #007",
        img: skyline9,
        collectionName: "Skyline9",
        author: "SkylineCity",
        bestOffer: "480",
        floorPrice: 380,
        currency: "QUANTA",
        annualYield: 6.2,
    },
    {
        name: "Sapphire Complex #15",
        img: platinum33,
        collectionName: "Platinum33",
        author: "PlatinumTowers",
        bestOffer: "2380",
        floorPrice: 2140,
        currency: "QUANTA",
        annualYield: -15.3,
    },
    {
        name: "Crystal Bay #88",
        img: ocean15,
        collectionName: "Ocean15",
        author: "OceanView",
        bestOffer: "1190",
        floorPrice: 95,
        currency: "QUANTA",
        annualYield: 11.8,
    },
    {
        name: "Titanium Elite #999",
        img: techhub44,
        collectionName: "TechHub44",
        author: "TechDistrict",
        bestOffer: "1900",
        floorPrice: 1660,
        currency: "QUANTA",
        annualYield: 8.2,
    },
];
